<template>
    <div class="sidebox" :class="value ? 'active' : ''">
        <div class="sidebox-close-btn" @click="handleClose">
            <i class="el-icon-d-arrow-right"></i>
        </div>
        <div class="sidebox-content">
            <slot />
        </div>
    </div>
</template>

<script>
    import popup from 'vue-popup';
    import { isEmpty } from 'lodash';

    export default {
        name: 'Sidebox',
        mixins: [popup],
        created () {
            this._registerGlobalClick();
        },
        destroyed () {
            this._destroyGlobalClick();
        },
        methods: {
            _registerGlobalClick () {
                document.addEventListener('click', this._handleGlobalClick);
            },
            _destroyGlobalClick () {
                document.removeEventListener('click', this._handleGlobalClick);
            },
            _handleGlobalClick (event) {
                if (event && event.target) {
                    // 判断全局点击事件是否在sidebox内部
                    // 如果在sidebox内部，不需要关闭sidebox
                    let parentContianer = event.target.closest('.sidebox');
                    if (isEmpty(parentContianer)) {
                        this.handleClose();
                    }
                }
            },
            handleClose () {
                this.close();
            }
        }
    };
</script>


<style lang="less">
    .sidebox {
        position: fixed;
        z-index: 1;
        right: 0;
        top: 86px;
        height: 100%;
        max-width: 1000px;
        background: #fff;
        box-shadow: -2px 0 20px 0 rgba(0,0,0,0.2);
        transition: transform ease .4s;
        transform: translateX(120%);
        display: flex;

        &.active {
            transform: translateX(0%);
        }

        .sidebox-close-btn {
            cursor: pointer;
            width: 20px;
            display: flex;
            align-items: center;
        }
        .sidebox-close-btn:hover {
            background: #fbfbfb;
        }

        .sidebox-content {
            padding: 0 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Sidebox/Sidebox.vue